import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { Box, Typography } from '@mui/material';

export const OutfitTitle = () => {
	const { productSelectCount, isValidSizesSelection } = useModalOutfitsContext();

	return (
		<Box>
			<Typography
				sx={{
					color: '#2A2A2A',
					fontWeight: 800,
					fontSize: { xs: '18px', md: '24px' },
					textTransform: 'uppercase',
				}}
			>
				{`COMPRA EL LOOK (${productSelectCount})`}
			</Typography>
			{!isValidSizesSelection ? (
				<Typography
					sx={{
						color: '#2A2A2A',
						fontWeight: 500,
						fontSize: { xs: '14px', md: '15px' },
					}}
				>
					{'Selecciona la talla de tus productos favoritos'}
				</Typography>
			) : null}
		</Box>
	);
};
